/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../core/models/Node';
import { ModelClonerVisitor } from './ModelClonerVisitor';
import { DocumentType } from '../core/models/DocumentType';
import { Document } from '../core/models/Document';
import { Aai20ModelClonerVisitor } from './Aai20ModelClonerVisitor';
import { Oas20ModelClonerVisitor } from './Oas20ModelClonerVisitor';
import { Oas30ModelClonerVisitor } from './Oas30ModelClonerVisitor';

/**
 * Class used to create an empty clone of any data model node.
 * @author eric.wittmann@gmail.com
 * @class
 */
export class ModelCloner {
    public static createEmptyClone(source : Node) : Node {
        let visitor : ModelClonerVisitor = null;
        switch((source.ownerDocument().getDocumentType())) {
        case DocumentType.asyncapi2:
            visitor = new Aai20ModelClonerVisitor();
            break;
        case DocumentType.openapi2:
            visitor = new Oas20ModelClonerVisitor();
            break;
        case DocumentType.openapi3:
            visitor = new Oas30ModelClonerVisitor();
            break;
        default:
            break;
        }
        if(visitor == null) {
            throw Object.defineProperty(new Error("No model cloner found for: " + source.ownerDocument().getDocumentType()), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
        }
        source.accept(visitor);
        return visitor.getClone();
    }
}
ModelCloner["__class"] = "io.apicurio.datamodels.cloning.ModelCloner";



